export const RouteType = {
  SERVICE: "/service",
  LOGIN: "/login",
  CHECKOUT: "/payment",
  PAYMENTINIT: "/paymentInit",
  PAY: "/pay",
  PAYMENT_ACTIVE: "/paymentActive",
  STATUS: "/status",
  PURPOSE: "/transaction/purpose",
};
